export default {"src":"/_next/static/media/powerOnIcon.6c82b403.svg","height":29,"width":26,"blurWidth":0,"blurHeight":0};